import Base from './base'

export default class MelodyPeople extends Base {
  async findByEmail(email) {
    try {
      return this.api.get(`people/find.json?email=${encodeURIComponent(email)}`)
    } catch (e) {
      return null
    }
  }

  create(payload) {
    return this.api.post('people', payload)
  }

  update(userId, payload) {
    return this.api.put(`people/${userId}.json`, payload)
  }

  getActiveCadences(ids) {
    return this.api.post('people/active_cadences.json', {
      people: ids,
    })
  }
}
